import { ArrowPosition } from '@ael/core-api';
import { HotspotStyle, PanoramaRenderApi } from '@ael/core-api';

export class HotspotRenderer {
  _name: string;
  _style: HotspotStyle;
  private _points: ArrowPosition[];
  private _onClick: (() => void) | undefined;

  constructor(name: string, style: HotspotStyle, points: ArrowPosition[], onClick?: () => void) {
    this._name = name;
    this._style = style;
    this._points = points;
    this._onClick = onClick;
  }

  render(pano: PanoramaRenderApi): void {
    const hotspot = pano.addHotspot(this._name);
    hotspot.loadstyle(this._style);
    this._points.forEach((point: { xAxis: number; yAxis: number }, index) => {
      pano.setHotspotPointPosition(this._name, index, point.xAxis, point.yAxis);
    });
    hotspot.onclick = this._onClick;
  }
}
